<template>
    <Card :bordered="false" class="border-radius-0" :loading="data.isLoading">
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <Tabs v-model:activeKey="menuContext.tabKey" type="card">
            <TabPane v-for="tab in data.tabs" :key="tab" :tab="$t(`views.setting.application.tab.${tab}.title`)">
                <ApplicationTab :list="listComputed"></ApplicationTab>
                <template v-if="tab === 'SMTP'">
                    <div class="text-center">
                        <Button class="btn-primary" @click="() => onClickTestEmail({ data })">
                            <span>{{ $t(`button.testEmail`) }}</span>
                        </Button>
                    </div>
                </template>
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
import { Button, Card, Tabs } from "ant-design-vue";
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../../app.logic";
import { createData, createOnSearch, getList, initForm, onClickTestEmail } from "./application.logic";

export default defineComponent({
    components: {
        Card,
        Tabs,
        TabPane: Tabs.TabPane,
        Button,
        ApplicationTab: defineAsyncComponent(() => import("./ApplicationTab"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        setAppPageHeader: { default: true }
    },
    setup(props) {
        if (!props.menuContext.tabKey) {
            // eslint-disable-next-line vue/no-mutating-props
            props.menuContext.tabKey = "APP";
        }
        const data = createData();
        const refs = reactive({});
        const onSearch = createOnSearch({ data });
        initForm({ props, data, refs, onSearch });
        onSearch(data);
        const listComputed = computed(() => getList({ data, group: props.menuContext.tabKey }));
        return { data, listComputed, onClickTestEmail };
    }
});
</script>
